import React, { useState, useEffect } from "react"

export const useVerticalTextSlider = (texts, interval = 2000) => {
  const [index, setIndex] = useState(0)

  useEffect(() => {
    const intervalId = setInterval(() => {
      setIndex((index) => (index + 1) % texts.length)
    }, interval)

    return () => clearInterval(intervalId)
  }, [texts.length, interval])

  return texts.map((text, i) => (
    <h1
      className={`slider-text ${i === index ? "active" : "inactive"}`}
      key={i}
      style={{
        position: "absolute",
        top: `${100 * (i - index)}%`,
        transition: "top 1s",
      }}
    >
      {text}
    </h1>
  ))
}